import { SceneObjects } from '@types'
import { toVector3 } from '@utils/conversion/toVector3'
import { getAngle2D } from '@utils/generalMaths/geometry'
import { pi, pipi } from '../../../store/baseValues'
import isWall from '../assertions/isWall'

export function dragFromRightVertex(item: SceneObjects, xE: number, zE: number) {
  const notEnd: [number, number] = [0, 0]
  if (!isWall(item)) return { x: 0, z: 0, rotation: 0, width: 0, end: notEnd }
  const start = item.start
  const { angle: rotation } = getAngle2D(start, [xE, zE]) //This should be the same vector as when drawing line.
  const width = toVector3([start[0], 0, start[1]]).distanceTo(toVector3([xE, 0, zE]))
  const thickness = item.thickness / 2
  const finalEnd: [number, number] = [xE, zE]
  return {
    x: (start[0] + xE) / 2 + thickness * Math.sin(rotation),
    z: (start[1] + zE) / 2 - thickness * Math.cos(rotation),
    rotation: rotation > pi ? -pipi + rotation : rotation % pipi,
    width,
    end: finalEnd,
  }
}
